import landingPage from './pages/landingPage';
import summaryPage from './pages/summaryPage';
import surveyPage from './pages/surveyPage';
import detailsPage from './pages/detailsPage';

export default {
  landing: landingPage,
  summary: summaryPage,
  survey: surveyPage,
  details: detailsPage
};


// WEBPACK FOOTER //
// ./src/main/js/pageMappings.js